import ky, { HTTPError } from "ky";
import { API_BASE_MM } from "@/constants/api";
import { createUnauthorizedHook } from "@/apis/clients/kyHooks";

export interface T1UserSession {
  user_id: string;
  username: string;
  first_name: string;
  last_name: string;
  is_global_admin: boolean;
  roles: number[];
}

const createT1AdminClient = () =>
  ky.create({
    baseUrl: API_BASE_MM,
    credentials: "same-origin",
    hooks: {
      afterResponse: [createUnauthorizedHook()],
    },
  });

/**
 * Fetches the caller's T1 session, which includes their role assignments.
 *
 * Returns null on 401 — the caller has no valid upstream session — so the
 * caller is treated as having no roles rather than as an error. Any other
 * failure throws, matching the pattern in sessionClient.
 */
export const fetchT1UserSession = async (): Promise<T1UserSession | null> => {
  try {
    return await createT1AdminClient()
      .get("admin/api/session")
      .json<T1UserSession>();
  } catch (error) {
    if (error instanceof HTTPError && error.response.status === 401) {
      return null;
    }
    throw error;
  }
};
